import {STORE_PRODUCT_COSTS} from "../../constants/productCosts";

const initialState = {
    productCosts: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_PRODUCT_COSTS:
            return {
                ...state,
                productCosts: action.productCosts
            }
            default:
                return state;
    }
}